const BugsnagAdapter = {
  notify: (message, e, errObj, ignoreConsole) => {
    let messages = Object.assign({ message: String(errObj) }, errObj);
    if (!ignoreConsole) {
      console.error(message, e);
    }
    if (window.Bugsnag) {
      window.Bugsnag.notify(e, function (event) {
        event.severity = "error";
        event.context = message;
        event.addMetadata("Err Message", messages);
      });
    }
  },
};

export { BugsnagAdapter };
